import type { NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

// Public CDN address of the hero photo in the site's storage.
export const HERO_IMAGE_URL = 'https://mario-flawless.cdn.modulify.website/images/hero/mario-flawless-workspace.jpg'

export const siteConfig: SiteConfig = {
    name: 'Mario Flawless',
    description: "Welcome to Mario Flawless' Freelancer Portfolio. Discover cutting-edge website design and app development services. Navigate with ease through showcased projects and client success stories.",
    url: getOrigin(),
    ogImage: HERO_IMAGE_URL
}

export const CONTACT_HREF = '/#contact'

export const PORTFOLIO_HREF = '/#portfolio'

export const HOME_NAV_LINKS: Array<NavItem> = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: 'Testimonials', href: '/#testimonials' }
]

export const SERVICES_NAV_LINKS: Array<NavItem> = [
    { label: 'Home', href: '/' },
    { label: 'Projects', href: PORTFOLIO_HREF }
]

export const PROJECT_TYPES = [
    { value: 'website', label: 'Website', detail: 'WordPress' },
    { value: 'app', label: 'App', detail: 'FlutterFlow' }
] as const

export type ProjectTypeValue = typeof PROJECT_TYPES[number]['value']
